module.exports = __webpack_public_path__ + "static/who-is-michael-ovitz-43cdf768464b193c0e39500958dc58cc.jpg";